import React, {useState} from "react";

const SearchKumpulanDataCompOpenData = ({onSearch}) =>{
    const [query, setQuery] = useState('');

    const handleChange = (e) => {
        setQuery(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Mencegah reload halaman
        onSearch(query); // Panggil fungsi pencarian
    };

    const backgroundImageStyle = {
        backgroundImage: `url('${process.env.PUBLIC_URL}/template/img/asset/kab_sampang.jpg')`
    };
    return(
        <section id="top" className="d-flex align-items-center bg-image-top" style={backgroundImageStyle}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12  text-center pt-5 pt-lg-0" data-aos="fade-up">
                        <div>
                            <h1>Dataset</h1>
                            <h2 className="color-dark">Pada halaman ini Anda dapat menemukan kumpulan data <br/> yang dipublikasikan dari berbagai organisasi pemerintahan di Kabupaten Sampang.</h2>
                            
                        </div>
                    </div>
                    {/* <div className="col-lg-12" data-aos="fade-up">
                        <div id="search">
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <form onSubmit={handleSubmit}>
                                        <input 
                                            type="text" 
                                            name="search" 
                                            placeholder="Search Data"
                                            value={query} 
                                            onChange={handleChange} 
                                        
                                        />
                                        <input 
                                            type="submit" 
                                            value="Search"
                                            // onClick={handleSearchClick} 
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default SearchKumpulanDataCompOpenData;